import {DefaultValue} from 'recoil';

type OneLevelDeepObject = Record<string, string | boolean | number | undefined>

/**
 * Guard against recoil default values in selector set functions.
 * Example:
 *  if (guardRecoilDefaultValue(newValue)) { return; }
 * @param candidate
 */
export const guardRecoilDefaultValue = (candidate: unknown): candidate is DefaultValue => {
    return candidate instanceof DefaultValue;
};

export const throwWriteOnlySelectorError = () => {
    throw new Error('This is a write-only selector');
};

export const compareObjects = <ObjectType extends OneLevelDeepObject>(object1: ObjectType, object2: ObjectType) => {
    return JSONstringifyOrder(object1) === JSONstringifyOrder(object2);
};

export const JSONstringifyOrder = (obj: OneLevelDeepObject) => {
    return JSON.stringify(obj, Array.from(Object.keys(obj)).sort());
};
